import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import heroBg from "../assets/hero-bg.png";

const WEB3FORMS_ACCESS_KEY = "b2123141-46d9-479a-a30a-24d5f9ff5c89";



const inputClass =
  "rounded-lg border border-gray-200 p-3 text-sm outline-none transition focus:border-[#ed860f] focus:ring-2 focus:ring-[#ed860f]/15";

const initialFormData = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};

const Contactus = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState({
    type: "",
    message: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!formData.firstName.trim() || !formData.email.trim() || !formData.message.trim()) {
      setFormStatus({
        type: "error",
        message: "Please fill first name, email, and message.",
      });
      return;
    }

    setIsSubmitting(true);
    setFormStatus({ type: "", message: "" });

    const fullName = `${formData.firstName} ${formData.lastName}`.trim();

    const payload = {
      access_key: WEB3FORMS_ACCESS_KEY,
      from_name: fullName || "Website Contact",
      subject: formData.subject.trim() || "New Contact Form Submission",
      name: fullName,
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
      source: "Veyonta Contact Us Page",
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "Message failed. Please try again.");
      }

      setFormData(initialFormData);
      setFormStatus({
        type: "success",
        message: "Message sent successfully. We will contact you soon.",
      });
    } catch (error) {
      setFormStatus({
        type: "error",
        message: error.message || "Something went wrong. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />

      <section className="relative overflow-hidden">
        <div
  className="relative min-h-[650px] bg-cover bg-center lg:min-h-[550px]"
  style={{ backgroundImage: `url(${heroBg})` }}
>
          <div className="absolute inset-0 bg-black/70" />

        <div className="relative z-10 flex min-h-[450px] items-center justify-center px-6 text-center lg:min-h-[650px]">
            <div className="max-w-4xl">
              <h1 className="text-4xl font-bold text-white sm:text-5xl lg:text-6xl">
                Contact Us
              </h1>

              <div className="mx-auto mt-4 h-[3px] w-40 rounded-full bg-[#ed860f]" />

              <p className="mt-6 text-lg text-white/80">
                We'd love to hear from you. Get in touch with our team for
                product inquiries, support, or partnership opportunities.
              </p>
            </div>
          </div>
        </div>
      </section>

      <main className="bg-[#f5f5f5] pt-[160px] sm:pt-[180px] lg:pt-[100px]">
        <section className="mx-auto max-w-4xl px-6 py-20">


          <div className="rounded-3xl bg-white p-8 shadow-xl lg:p-10">
            <h2 className="mb-8 text-center text-3xl font-bold text-black">
              Send us a Message
            </h2>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <input
                type="checkbox"
                name="botcheck"
                className="hidden"
                tabIndex="-1"
                autoComplete="off"
              />

              <div className="grid gap-4 sm:grid-cols-2">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First name"
                  value={formData.firstName}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />

                <input
                  type="text"
                  name="lastName"
                  placeholder="Last name"
                  value={formData.lastName}
                  onChange={handleChange}
                  className={inputClass}
                />
              </div>

              <div className="grid gap-4 sm:grid-cols-2">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className={inputClass}
                  required
                />

                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone number"
                  value={formData.phone}
                  onChange={handleChange}
                  className={inputClass}
                />
              </div>

              <input
                type="text"
                name="subject"
                placeholder="Subject"
                value={formData.subject}
                onChange={handleChange}
                className={`w-full ${inputClass}`}
              />

              <textarea
                name="message"
                placeholder="Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                className={`w-full resize-none ${inputClass}`}
                required
              />

              {formStatus.message && (
                <p
                  className={`rounded-lg px-4 py-3 text-sm font-medium ${formStatus.type === "success"
                      ? "bg-green-50 text-green-700"
                      : "bg-red-50 text-red-700"
                    }`}
                >
                  {formStatus.message}
                </p>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full rounded-lg bg-[#ed860f] py-4 font-bold text-white transition hover:bg-[#d9780d] disabled:opacity-70"
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </section>
        <section className="mx-auto px-6 py-10">
          <div className="h-[400px] w-full overflow-hidden rounded-3xl border border-gray-100 shadow-lg">
            <iframe
              title="Veyonta Location Map"
              className="h-full w-full"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14072.103355481162!2d75.51531384363776!3d28.145701592727793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391324cf13d1e6df%3A0xa277ecdcc274a71b!2sIslampur%2C%20Rajasthan%20333024!5e0!3m2!1sen!2sin!4v1781003824611!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Contactus;